import { defineMessages } from 'react-intl';

export const subscriptionsMessages = defineMessages({
    trialing: {
        id: 'trialing',
        defaultMessage: 'Trialing',
    },
    trial: {
        id: 'trial',
        defaultMessage: 'Trial',
    },
    trialStart: {
        id: 'trial-start',
        defaultMessage: 'Trial start',
    },
    trialEnd: {
        id: 'trial-end',
        defaultMessage: 'Trial end',
    },
    trialPlanDefault: {
        id: 'trial-plan-default',
        defaultMessage: "Use the plan's trial period",
    },
    trialNone: {
        id: 'trial-none',
        defaultMessage: 'No trial',
    },
    trialCustom: {
        id: 'trial-custom',
        defaultMessage: 'Custom trial end date',
    },
    endTrial: {
        id: 'end-trial',
        defaultMessage: 'End trial',
    },
    endTrialSubtitle: {
        id: 'end-trial-subtitle',
        defaultMessage: 'End the trial for subscription {entity}',
    },
    confirmEndTrial: {
        id: 'confirm-end-trial',
        defaultMessage: 'This converts the subscription immediately and pulls its first bill forward. Continue?',
    },
    endTrialSuccess: {
        id: 'end-trial-success',
        defaultMessage: 'Trial ended',
    },
    endTrialSuccessDescription: {
        id: 'end-trial-success-description',
        defaultMessage: 'The subscription has been converted and billing has been pulled forward.',
    },
    planChangeScheduled: {
        id: 'plan-change-scheduled',
        defaultMessage: 'Scheduled',
    },
    planChangeApplied: {
        id: 'plan-change-applied',
        defaultMessage: 'Applied',
    },
    planChangeCancelled: {
        id: 'plan-change-cancelled',
        defaultMessage: 'Cancelled',
    },
    planChangeFailed: {
        id: 'plan-change-failed',
        defaultMessage: 'Failed',
    },
    planChangeHint: {
        id: 'plan-change-hint',
        defaultMessage: 'To move this subscription to another plan, use Schedule plan change on the dashboard.',
    },
    schedulePlanChange: {
        id: 'schedule-plan-change',
        defaultMessage: 'Schedule plan change',
    },
    schedulePlanChangeSubtitle: {
        id: 'schedule-plan-change-subtitle',
        defaultMessage: 'Move this subscription to another plan at its next period boundary',
    },
    targetServicePlan: {
        id: 'target-service-plan',
        defaultMessage: 'New plan',
    },
    effectiveDate: {
        id: 'effective-date',
        defaultMessage: 'Effective date',
    },
    effectiveDateHint: {
        id: 'effective-date-hint',
        defaultMessage:
            'Leave empty to use the earliest next billing date across active items. A past date is applied immediately if nothing from that date on has been billed yet.',
    },
    planChangeItemsHint: {
        id: 'plan-change-items-hint',
        defaultMessage:
            'Items are matched by code: matching items keep their quantity history, items with no match on the new plan end, and new required items are created.',
    },
    schedulePlanChangeSuccess: {
        id: 'schedule-plan-change-success',
        defaultMessage: 'Plan change scheduled',
    },
    schedulePlanChangeSuccessDescription: {
        id: 'schedule-plan-change-success-description',
        defaultMessage: 'The subscription will move to {entity} on the effective date.',
    },
    cancelPlanChange: {
        id: 'cancel-plan-change',
        defaultMessage: 'Cancel plan change',
    },
    confirmCancelPlanChange: {
        id: 'confirm-cancel-plan-change',
        defaultMessage: 'Are you sure you want to cancel the scheduled plan change?',
    },
    cancelPlanChangeSuccess: {
        id: 'cancel-plan-change-success',
        defaultMessage: 'Plan change cancelled',
    },
    cancelPlanChangeSuccessDescription: {
        id: 'cancel-plan-change-success-description',
        defaultMessage: 'The scheduled plan change has been cancelled.',
    },
    scheduledPlanChangeBanner: {
        id: 'scheduled-plan-change-banner',
        defaultMessage: 'Changing to {plan} on {date}',
    },
    subscriptions: {
        id: 'subscriptions',
        defaultMessage: 'Subscriptions',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    subscriptionsTableBadge: {
        id: 'subscriptions-table-badge',
        defaultMessage: 'Subscriptions',
    },
    refNumber: {
        id: 'ref-number',
        defaultMessage: 'Ref number',
    },
    externalId: {
        id: 'external-id',
        defaultMessage: 'External ID',
    },
    startDate: {
        id: 'start-date',
        defaultMessage: 'Start date',
    },
    endDate: {
        id: 'end-date',
        defaultMessage: 'End date',
    },
    status: {
        id: 'status',
        defaultMessage: 'Status',
    },
    active: {
        id: 'active',
        defaultMessage: 'Active',
    },
    cancelled: {
        id: 'cancelled',
        defaultMessage: 'Cancelled',
    },
    endedSubscription: {
        id: 'ended-subscription',
        defaultMessage: 'Past',
    },
    frozen: {
        id: 'frozen',
        defaultMessage: 'Frozen',
    },
    cancelledAt: {
        id: 'cancelled-at',
        defaultMessage: 'Cancelled at',
    },
    lockedAt: {
        id: 'locked-at',
        defaultMessage: 'Locked at',
    },
    stoppedOn: {
        id: 'stopped-on',
        defaultMessage: 'Stopped on',
    },
    activeBilling: {
        id: 'active-billing',
        defaultMessage: 'Active billing',
    },
    createSubscriptionSuccess: {
        id: 'create-subscription-success',
        defaultMessage: 'Subscription created',
    },
    createSubscriptionSuccessDescription: {
        id: 'create-subscription-success-description',
        defaultMessage: 'The subscription has been successfully created.',
    },
    addSubscriptionSubtitle: {
        id: 'add-subscription-subtitle',
        defaultMessage: 'Create a new subscription',
    },
    deleteSubscription: {
        id: 'delete-subscription',
        defaultMessage: 'Delete subscription',
    },
    deleteSubscriptionSuccess: {
        id: 'delete-subscription-success',
        defaultMessage: 'Subscription deleted',
    },
    deleteSubscriptionSuccessDescription: {
        id: 'delete-subscription-success-description',
        defaultMessage: 'The subscription has been successfully deleted.',
    },
    confirmDeleteSubscription: {
        id: 'confirm-delete-subscription',
        defaultMessage: 'Are you sure you want to delete this subscription? This action cannot be undone.',
    },
    deleteSubscriptionSubtitle: {
        id: 'delete-subscription-subtitle',
        defaultMessage: 'Permanently delete subscription',
    },
    editSubscriptionSubtitle: {
        id: 'edit-subscription-subtitle',
        defaultMessage: 'Edit subscription',
    },
    updateSubscriptionSuccess: {
        id: 'update-subscription-success',
        defaultMessage: 'The subscription was updated',
    },
    updateSubscriptionSuccessDescription: {
        id: 'update-subscription-success-description',
        defaultMessage: 'The subscription has been successfully updated.',
    },
    subscriptionDashboard: {
        id: 'subscription-dashboard',
        defaultMessage: 'Subscription dashboard',
    },
    backToAllSubscriptions: {
        id: 'back-to-all-subscriptions',
        defaultMessage: 'Back to all subscriptions',
    },
    inactiveServicePlanError: {
        id: 'custom-error:subscription_with_inactive_service_plan',
        defaultMessage: 'The selected service plan is not active. Choose an active plan!',
    },
    changeServicePlanError: {
        id: 'custom-error:change_subscription_service_plan',
        defaultMessage:
            'The service plan of an existing subscription cannot be changed, because its items belong to the original plan. Cancel this subscription and create a new one on the desired plan instead!',
    },
    modifyInactiveSubscriptionError: {
        id: 'custom-error:modify_inactive_subscription',
        defaultMessage: 'The subscription has already been cancelled or ended!',
    },
    subscriptionNotInTrialError: {
        id: 'custom-error:subscription_not_in_trial',
        defaultMessage: 'This subscription is not in a trial.',
    },
    noScheduledPlanChangeError: {
        id: 'custom-error:no_scheduled_plan_change',
        defaultMessage: 'There is no scheduled plan change to cancel.',
    },
    samePlanChangeError: {
        id: 'custom-error:same_plan_change',
        defaultMessage: 'The subscription is already on that plan.',
    },
    planChangeCurrencyMismatchError: {
        id: 'custom-error:plan_change_currency_mismatch',
        defaultMessage: 'The target plan uses a different currency.',
    },
    modifyStartedSubscriptionError: {
        id: 'custom-error:modify_started_subscription',
        defaultMessage: 'Subscription cannot be modified because it already has started!',
    },
});
